import { render } from "./MenuMesas.vue?vue&type=template&id=3bfeacd0&scoped=true"
import script from "./MenuMesas.vue?vue&type=script&lang=js"
export * from "./MenuMesas.vue?vue&type=script&lang=js"

import "./MenuMesas.vue?vue&type=style&index=0&id=3bfeacd0&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfeacd0"]])

export default __exports__